import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar, Container, Dropdown } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { FaSun, FaMoon } from "react-icons/fa";

import "../headernavbar.css";

export default function Header({ toggleSidebar, toggleCollapse, sidebarOpen }) {
  const navigate = useNavigate();

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = screenSize < 768;

  const handleLogout = () => {
    localStorage.clear();
    navigate("/", { replace: true });
  };

  const handleToggle = () => {
    if (isMobile) {
      toggleSidebar();
    } else {
      toggleCollapse();
    }
  };

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <Navbar
      className={`header ${sidebarOpen ? "mobile-open" : ""}`}
      expand="lg"
    >
      <Container fluid className="d-flex">
        <div className="d-flex  left-section">
          <div className="d-flex flex-row align-items-center">
            {isMobile && (
              <button className="menu-btn" onClick={handleToggle}>
                <FaBars size={18} />
              </button>
            )}
            <h5 className="mb-0 header-title">Welcome !</h5>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end gap-2 gap-md-3 rightside-header">
          {/* Theme Toggle */}
          <div className="theme-switch" onClick={toggleTheme}>
            <div className={`switch ${theme}`}>
              <span className="icon sun">
                <FaSun />
              </span>

              <span className="icon moon">
                <FaMoon />
              </span>

              <div className="toggle-circle"></div>
            </div>
          </div>

          {/* Profile Dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle id="dropdown-profile" className="profile-toggle">
              <div className="profile-circle">A</div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="profile-menu my-3 my-md-4">
              <div className="profile-header">
                <div className="profile-circle large">A</div>
                <div>
                  <div className="profile-name">Super Admin</div>
                  <div className="profile-email">kvlmatri@gmail.com</div>
                </div>
              </div>

              <Dropdown.Divider />

              <Dropdown.Item onClick={handleLogout} className="logout-btn">
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Container>
    </Navbar>
  );
}
